import { FC, useMemo } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext.tsx';
import Routes from '@/router/Routes.ts';
import { familyMemberNavData, businessProviderNavData, adminNavData } from '@/layouts/Default/config-nav.tsx';

const DashboardRedirect: FC = () => {
  const { currentUser } = useAuthContext();

  const redirectPath = useMemo(() => {
    const role = currentUser?.role;

    if (role === 'admin') {
      return adminNavData[0]?.path ?? Routes.CARERS;
    }

    if (role === 'business_provider') {
      return businessProviderNavData[0]?.path ?? Routes.INTRO_CALLS;
    }

    return familyMemberNavData[0]?.path ?? Routes.CARERS;
  }, [currentUser]);

  return <Navigate to={redirectPath} replace />;
};

export default DashboardRedirect;
